import { Button, Modal } from "abs-ui-components";
import AbsModal from "../../common/absModal/AbsModal";
import axiosHttp from "../../services/interceptor";
import { accessAPIForResponse } from "../../services/api-services/api-implementations";
const baseURL = process.env.REACT_APP_BASE_URL;
export const getColumns = ({
    user,
    engineersOptions,
    pendingColumnFilters,
    getFilterValue,
    updateFilterValue,
    handleClaim,
    handleUnClaim,
    handleAssignClick,
}) => [
        // all columns here
    ];
export const AssignReviewerModal = ({open,selectedEngineer,onSelect,onAssign,onClose,getAllEngineers}) => {
    return (
        <AbsModal
            isOpen={open}
            title="Assignment"
            onClose={onClose}
            close={onClose}
        >
            {/* modal content */}
        </AbsModal>
    );
};


export const DeleteConfirmationModal = ({open,onDelete,onClose}) => {
    if (!open) return null;

    return (
        <Modal
            isOpen={open}
            modalHeader
            showFooter
            onCloseClickListener={onClose}
            footer={
                <>
                    <Button onClick={onDelete}>
                        Delete
                    </Button>

                    <Button onClick={onClose}>
                        Cancel
                    </Button>
                </>
            }
        >
            Are you sure you want to delete this CVR Report?
        </Modal>
    );
};

export const getCompanyVerificationGrid = (baseURL,payload) => {
    return axiosHttp.post(
        `${baseURL}api/CompanyVerification/GetCompanyVerificationReportGrid/1001`,
        payload
    );
};

export const assignReviewer = (
    reportId,
    userEmail
) => {
    return axiosHttp.post(
        `${baseURL}api/CompanyVerification/assign-reviewer`,
        null,
        {
            params: {
                companyVerificationReportId: reportId,
                userEmail: userEmail,
            },
        }
    );
};

export const claimReport = (baseURL,reportId,userEmail) => {
    return axiosHttp.post(
        `${baseURL}api/CompanyVerification/Claim-report`,
        null,
        {
            params: {
                companyVerificationReportId: reportId,
                userEmail,
            },
        }
    );
};

export const unclaimReport = (reportId,userEmail) => {
    return axiosHttp.post(
        `${baseURL}api/CompanyVerification/UnClaim-report`,
        null,
        {
            params: {
                companyVerificationReportId: reportId,
                userEmail,
            },
        }
    );
};

export const deleteReport = (reportId) => {
    return axiosHttp.post(
        `${baseURL}api/CompanyVerification/delete-report`,
        null,
        {
            params: {
                companyVerificationReportId: reportId,
            },
        }
    );
};

export const getReviewEngineers = (input) => {
    return accessAPIForResponse(
        "GetReviewEngineers",
        null,
        [input]
    );
};

export const downloadAllReportDocuments = async (companyVerificationReportId) => {
    return axiosHttp({
        url: "/api/CompanyVerification/download-report-docs",
        method: "GET",
        params: {
            companyVerificationReportId,
        },
        responseType: "blob",
    });
};

export const wcnLoadOptions = async (inputValue) => {
    const requestedPayload = { searchKey: inputValue };
    try {
        const response = await axiosHttp.post(`${baseURL}api/Wcn/SearchWcn`, requestedPayload);
        const formattedWCNOptions = response?.data?.map((item) => ({
            label: `${item.CompanyName}`,
            value: `${item.WcnNumber}`,
            wcnMappingId: item.WcnMstId,
            controlRiskId: item.ControlRiskId,
            inherentRiskId: item.InherentRiskId,
        }));
        return formattedWCNOptions;
    } catch (error) {
        return [];
    }
};

export const searchWcn = async (searchKey) => {
    return axiosHttp.post(
        `${baseURL}api/Wcn/SearchWcn`,
        { searchKey }
    );
};

const ACTIVE_STATUSES = [
    "Crosscheck In Progress",
    "Verification In Progress",
];

export const getDeleteState = ({
    reviewerRole,
    verifierRole,
    superAdminRole,
    status,
}) => {
    // Client (none of the roles)
    if (!reviewerRole && !verifierRole && !superAdminRole) {
        return { show: false, disabled: true };
    }

    // Superadmin
    if (superAdminRole) {
        return { show: true, disabled: false };
    }

    // Reviewer / Verifier
    if (ACTIVE_STATUSES.includes(status)) {
        return { show: true, disabled: false };
    }

    if (status === "Verification Completed") {
        return { show: true, disabled: true };
    }

    return { show: false, disabled: true };
};
